module.exports = "/_next/static/images/CreateSingleViewOfTheCustomer@2x-b756bb0abc5b5a84e2629714df515a33.webp";